import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';

//Firebase
import { provideAuth, getAuth } from '@angular/fire/auth'
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';

//Environment
import { environment } from '../environments/environment';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

//DateTime Picker
import { LOCALE_ID } from '@angular/core';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime-ex';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    provideClientHydration(),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideAnimations(),

    //DateTime Picker
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'es' },
    DatePipe
  ]
};
